import { distanceTo, distanceUnits } from "./distanceTo";
export function getDistanceToCityCenter(poiCoordinates, places) {
    var city = Array.isArray(places) && places.filter(function (containingPlace) { return containingPlace.placeType === "city"; });
    if (!poiCoordinates || city.length === 0 || !city[0].center) {
        return "";
    }
    var cityCenter = city[0].center.coordinates;
    if (!cityCenter || cityCenter.length === 0) {
        return "";
    }
    var distanceToCityCenter = distanceTo(poiCoordinates, cityCenter);
    var amount = distanceToCityCenter[distanceUnits()].amount;
    var unit = distanceToCityCenter[distanceUnits()].unit;
    return amount + " " + unit + " to city center";
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/getDistanceToCityCenter.ts
// module id = YAHl
// module chunks = 2